<template>
  <div class="p-6">
    <div style="display: flex; align-items: flex-start; gap: 20px;">
      <div class="warning-text-inline" style="flex: 1; ">
        工人姓名：{{ this.userName }}
        &emsp;&emsp;&emsp;
        身份证号：{{ this.cardId }}
      </div>
    </div>

    <div class="mt-6">
      <a-table
        rowKey="id"
        bordered
        :loading="loading"
        :columns="tableColumns"
        :dataSource="dataSource"
        :pagination="false"
        :scroll="{
          x: 1200,
        }"
        size="small"
      ></a-table>
      <base-pagination
        class="mt-6"
        :totalCount.sync="totalCount"
        :pageNo.sync="pageNo"
        :pageSize.sync="pageSize"
        @change="pageChange"
        size="small"
      />
    </div>
    <OaDocModal ref="oaDocModal"></OaDocModal>
  </div>
</template>

<script>
import { queryViewMixin } from '@/utils/mixin'
import OaDocModal from './OaDocModal.vue'

export default {
  components: {
    OaDocModal,
  },
  mixins: [queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '项目',
        width: '15%',
        align: 'left',
        dataIndex: 'projectName',
      },
      {
        title: '班组',
        width: '10%',
        align: 'center',
        dataIndex: 'teamName',
      },
      {
        title: '支付单号',
        width: '12%',
        align: 'left',
        dataIndex: 'paymentCode',
      },
      {
        title: '流程状态',
        width: '10%',
        align: 'center',
        dataIndex: 'wfStatus',
      },
      {
        title: '本次支付金额',
        width: '10%',
        align: 'center',
        dataIndex: 'paymentAmount',
      },
      {
        title: '支付账号',
        width: '12%',
        align: 'left',
        dataIndex: 'paymentAccount',
      },
      {
        title: '支付状态',
        width: '10%',
        align: 'center',
        dataIndex: 'paymentStatus',
      },
      {
        title: '支付日期',
        width: '10%',
        align: 'left',
        dataIndex: 'paymentDate',
      },
      {
        title: '操作',
        width: 120,
        align: 'center',
        customRender: (text, row) => {
          return (
            <div>
              <div>
                {row.receiptFileList && row.receiptFileList.length ? (
                  <a
                    onClick={() => {
                      this.checkReceipt(row)
                    }}
                  >
                    查看收条
                  </a>
                ) : (
                  <span class="text-gray-400">查看收条</span>
                )}
              </div>
              <div>
                {row.promiseBookFileList && row.promiseBookFileList.length ? (
                  <a
                    onClick={() => {
                      this.checkCommitment(row)
                    }}
                  >
                    查看班组承诺书
                  </a>
                ) : (
                  <span class="text-gray-400">查看班组承诺书</span>
                )}
              </div>
            </div>
          )
        },
      },
    ]
    return {
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableColumns: tableColumns,
      dataSource: [],
      cardId: '',
      userName: '',
    }
  },
  methods: {
    async doQuery(_pageNo = this.pageNo, _pageSize = this.pageSize) {
      this.loading = true
      try {
        await this.$nextTick()
        const params = {
          identityNum: this.$route.query.cardId,
          pageNo: _pageNo,
          pageSize: _pageSize,
        }

        const res = await this.$axios.post('/report/oa/unpaid', params)
        const data = res.data || {}
        const list = data.list || []

        this.dataSource = list.map(item => ({
          id: item.id,
          projectName: item.prjname,
          teamName: item.className,
          paymentCode: item.bh,
          wfStatus: item.wsStatus,
          paymentAmount: item.amount,
          paymentAccount: item.account,
          paymentStatus: item.zfrq ? '已支付' : '未支付',
          paymentDate: item.zfrq,
          requestId: item.requestId,
          workerName: item.workerName,
          promiseBookFileList: item.fclsFileList || [],
          receiptFileList: item.fbzmqFileList || [],
        }))

        this.totalCount = data.totalCount || 0
        this.pageSize = data.pageSize || _pageSize
        this.pageNo = data.pageNo || _pageNo
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    getWfStatusText(status) {
      const statusMap = {
        1: '待审批',
        2: '审批中',
        3: '已通过',
        4: '已拒绝',
      }
      return statusMap[status] || '未知'
    },
    handleView(row) {
      console.log('查看详情', row)
    },
    async openOssUrl(ossUrl) {
      const res = await this.$axios.post('/report/evidence/chain/tmp/pathUrl', {
        ossUrl,
      })
      const url = res.data
      window.open(url)
    },
    checkCert(row) {
      this.openOssUrl(row.originCertificate)
    },
    checkReceipt(row) {
      this.$refs.oaDocModal.start(row.receiptFileList)
    },
    checkCommitment(row) {
      this.$refs.oaDocModal.start(row.promiseBookFileList)
    },
    pageChange(pageNo, pageSize) {
      this.doQuery(pageNo, pageSize)
    },
  },
  async mounted() {
    const { cardId, projectCode, leaderId } = this.$route.query
    const param = { cardId, projectCode, leaderId }
    const res = await this.$axios.post(`/report/evidence/chain/worker/Info`, param)
    this.userName = res.data.username
    this.cardId = cardId
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
</style>
